import { c as _c } from "react/compiler-runtime";
import React, { AriaAttributes } from 'react';
import classNames from 'classnames';
import { Breadcrumb } from '@udemy-v2/react-navigation-components';
import { CourseCategory, Topic } from '@udemy-v2/browse-course';
import styles from './breadcrumb-navigation.module.scss';
interface BreadcrumbNavigationProps {
  primaryCategory?: CourseCategory;
  primaryTopic?: Topic;
  ariaLabel?: AriaAttributes['aria-label'];
}
interface BreadcrumbItem {
  id: string;
  name: string;
  href: string;
}

/**
 * Displays a breadcrumb navigation from categories and additional items
 */
export function BreadcrumbNavigation(t0) {
  const $ = _c(24);
  const {
    primaryCategory,
    primaryTopic,
    ariaLabel
  } = t0;
  const primarySubcategory = primaryCategory?.subcategories?.[0];
  let breadcrumbItems;
  if ($[0] !== primaryCategory || $[1] !== primarySubcategory || $[2] !== primaryTopic) {
    breadcrumbItems = [];
    if (primaryCategory) {
      let t1;
      if ($[4] !== primaryCategory.id || $[5] !== primaryCategory.name || $[6] !== primaryCategory.url) {
        t1 = {
          id: primaryCategory.id,
          name: primaryCategory.name,
          href: primaryCategory.url
        };
        $[4] = primaryCategory.id;
        $[5] = primaryCategory.name;
        $[6] = primaryCategory.url;
        $[7] = t1;
      } else {
        t1 = $[7];
      }
      breadcrumbItems.push(t1);
    }
    if (primarySubcategory) {
      let t1;
      if ($[8] !== primarySubcategory.id || $[9] !== primarySubcategory.name || $[10] !== primarySubcategory.url) {
        t1 = {
          id: primarySubcategory.id,
          name: primarySubcategory.name,
          href: primarySubcategory.url
        };
        $[8] = primarySubcategory.id;
        $[9] = primarySubcategory.name;
        $[10] = primarySubcategory.url;
        $[11] = t1;
      } else {
        t1 = $[11];
      }
      breadcrumbItems.push(t1);
    }
    if (primaryTopic) {
      let t1;
      if ($[12] !== primaryTopic.id || $[13] !== primaryTopic.name || $[14] !== primaryTopic.url) {
        t1 = {
          id: primaryTopic.id,
          name: primaryTopic.name,
          href: primaryTopic.url
        };
        $[12] = primaryTopic.id;
        $[13] = primaryTopic.name;
        $[14] = primaryTopic.url;
        $[15] = t1;
      } else {
        t1 = $[15];
      }
      breadcrumbItems.push(t1);
    }
    $[0] = primaryCategory;
    $[1] = primarySubcategory;
    $[2] = primaryTopic;
    $[3] = breadcrumbItems;
  } else {
    breadcrumbItems = $[3];
  }
  if (breadcrumbItems.length === 0) {
    return null;
  }
  const shouldHideFirstOnMobile = breadcrumbItems.length === 3;
  const t1 = shouldHideFirstOnMobile && styles["hide-first-on-mobile"];
  let t2;
  if ($[16] !== t1) {
    t2 = classNames(styles["breadcrumb-container"], t1);
    $[16] = t1;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  const breadcrumbClassName = t2;
  let t3;
  if ($[18] !== breadcrumbItems) {
    t3 = breadcrumbItems.map((item, index) => <Breadcrumb.Item key={item.id} href={item.href} ariaCurrent={index === breadcrumbItems.length - 1 ? true : undefined}>{item.name}</Breadcrumb.Item>);
    $[18] = breadcrumbItems;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  let t4;
  if ($[20] !== ariaLabel || $[21] !== breadcrumbClassName || $[22] !== t3) {
    t4 = <Breadcrumb className={breadcrumbClassName} ariaLabel={ariaLabel}>{t3}</Breadcrumb>;
    $[20] = ariaLabel;
    $[21] = breadcrumbClassName;
    $[22] = t3;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  return t4;
}